import { render, staticRenderFns } from "./UnmatchedRuleCard.vue?vue&type=template&id=68ab8603&scoped=true&"
import script from "./UnmatchedRuleCard.vue?vue&type=script&lang=js&"
export * from "./UnmatchedRuleCard.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedRuleCard.vue?vue&type=style&index=0&id=68ab8603&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab8603",
  null
  
)

export default component.exports